export const CREDIT_CODE = 'SBPS-credit'
export const CREDIT_LABEL = 'クレジットカード'

export const DOCOMO_CODE = 'SBPS-docomo'
export const DOCOMO_LABEL = 'ドコモ払い'

export const KDDI_CODE = 'SBPS-au'
export const KDDI_LABEL = 'ａｕかんたん決済'

export const SOFTBANK_CODE = 'SBPS-softbank'
export const SOFTBANK_LABEL = 'ソフトバンクまとめて支払い'

export const PAYPAY_CODE = 'SBPS-paypay'
export const PAYPAY_LABEL = 'PayPay'

export const LINEPAY_CODE = 'SBPS-linepay'
export const LINEPAY_LABEL = 'LinePay'

export const CARRIER_LABEL = '携帯キャリア決済を使う'
export const PAY_LABEL = 'Pay決済を使う'

export const AMAZONPAY_CODE = 'AmazonPay'
export const AMAZONPAY_LABEL = 'Amazon Pay'



// WEBPACK FOOTER //
// ./resources/assets/js/CONSTS/PAYEE.js